import { css, cx } from '@emotion/css';
import { observer } from 'mobx-react-lite';

import { ReactComponent as ArrowLeftIcon } from '^/userWeb/Assets/Icons/arrow-left.svg';
import { ReactComponent as SettingIcon } from '^/userWeb/Assets/Icons/setting.svg';
import { NavigationBar } from '^/userWeb/Components/NavigationBar/NavigationBar';
import { routes } from '^/userWeb/routes';
import { fillParentElem, whiteBackground } from '^/userWeb/styles/commonClasses';

// export const DetectedVisitorsPage: React.FC<{
//   title: string;
//   viewmodel: DetectedVisitorsPageViewModel,
// }> = observer(function DetectedVisitorsPage({}) {

// }

export const StanzoneSimpleUnlockedPage: React.FC<{
  imageUrl: string,
  altText: string,
}> = observer(function StanzoneSimpleUnlockedPage(p) {
  const title = '스탠존 알림';

  const isSvg = p.imageUrl.endsWith('.svg');
  return (
    <div
      className={cx(
        fillParentElem, whiteBackground,
      )}
    >
      <NavigationBar
        LeftIcon={ArrowLeftIcon}
        title={title}
        RightIcon={SettingIcon}
        RightIconProps={{
          onClick() {
            routes.notificationSetting({}).push();
          },
        }}
        rootCSS={css`
          height: 60px;
        `}
      />
      <div
        id="StanzoneSimpleUnlockedPageInner"
      >

        {isSvg ? (
          <object
            aria-label={p.altText}
            id="SVGViewer1"
            data={p.imageUrl}
            type="image/svg+xml"
            className={css`
              width: 100%;
            `}
          // className={styles.svgObject}
          >
          </object>
        ) : (
          <img
            src={p.imageUrl}
            alt={p.altText}
          />

        )}

        <div>
          ✅ 스탠존 잠김 해제 완료!
        </div>
      </div>
    </div>

  );
});
